import LoadingModal from "lib/ui/modal/loading-modal";
import Modal from "lib/ui/modal/modal";
import React, { useEffect, useState } from "react";

import MeterManagementPageBody from "./meter-management-page-body";
import ProvisionMeterForm from "./provision-meter-form";
import { generateAccountData } from "./meters-data";
import { PageSubheader } from "../lib/page";
import { AltLayout } from "../common";

const MeterManagementPage = () => {
  const [isProvisioning, setIsProvisioning] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [autoCompleteData, setAutoCompleteData] = useState([]);

  // Replicating onComponentDidMount to get data
  useEffect(() => {
    generateAccountData({ offset: 0, limit: 20 }).then(customers => {
      setAutoCompleteData(customers.data);
      setIsLoading(false);
    });
    setIsLoading(true);
  }, []);

  const onProvisionClicked = () => {
    setIsProvisioning(!isProvisioning);
  };

  const onProvisionFormComplete = () => {
    setIsProvisioning(false);
  };

  const searchInfo = {
    placeholder: "Find a meter"
  };

  const buttonInfo = {
    text: "Provision",
    onClick: onProvisionClicked,
    displayAction: isProvisioning,
    actionBody: (
      <Modal isOpen={isProvisioning}>
        <ProvisionMeterForm
          formComplete={onProvisionFormComplete}
          autocompleteData={autoCompleteData}
        />
      </Modal>
    )
  };

  return (
    <AltLayout pageTitle="Meters">
      <>
        {isLoading && <LoadingModal isOpen={isLoading} />}
        {!isLoading && (
          <div className="h-full flex flex-col overflow-y-scroll">
            <PageSubheader
              searchInfo={searchInfo}
              buttonInfo={buttonInfo}
              body={<MeterManagementPageBody />}
            />
            <div className="max-h-full min-h-0 p-2 flex">
              <MeterManagementPageBody />
            </div>
          </div>
        )}
      </>
    </AltLayout>
  );
};

export default MeterManagementPage;
